import React, { useState } from 'react';
import { Modal, Alert, Typography, Space, Divider } from 'antd';
import { RobotOutlined, WarningOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const { Text, Paragraph } = Typography;

const UnmarkAiBotModal = ({ visible, onCancel, onConfirm, customer, loading }) => {
  if (!customer) return null;

  const detectedAt = customer.aiBotDetectedAt 
    ? format(new Date(customer.aiBotDetectedAt), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR })
    : 'Data desconhecida';

  return (
    <Modal
      title={
        <Space>
          <RobotOutlined style={{ color: '#ff4d4f' }} />
          <span>Desbloquear Cliente Marcado como Bot</span>
        </Space>
      }
      open={visible}
      onCancel={onCancel}
      onOk={onConfirm}
      confirmLoading={loading}
      okText="Sim, Desbloquear"
      cancelText="Cancelar"
      okButtonProps={{ danger: false, type: 'primary' }}
      width={600}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Alert
          message="Atenção: Falso Positivo?"
          description="Esta ação irá desbloquear o cliente e permitir que ele volte a ser atendido normalmente pelo sistema de IA."
          type="warning"
          showIcon
          icon={<WarningOutlined />}
        />

        <div>
          <Text strong>Cliente:</Text>
          <Paragraph style={{ marginTop: 4, marginBottom: 0 }}>
            {customer.name} {customer.nickname && `(${customer.nickname})`}
          </Paragraph>
        </div>

        <Divider style={{ margin: '12px 0' }} />

        <div>
          <Text strong>Informações da Detecção:</Text>
          <div style={{ marginTop: 8, paddingLeft: 16 }}>
            <div style={{ marginBottom: 4 }}>
              <Text type="secondary">Detectado em:</Text> {detectedAt}
            </div>
            {customer.aiBotDetectionReason && (
              <div style={{ marginBottom: 4 }}>
                <Text type="secondary">Motivo:</Text> {customer.aiBotDetectionReason}
              </div>
            )}
          </div>
        </div>

        <Divider style={{ margin: '12px 0' }} />

        <Alert
          message="O que acontecerá após desbloquear?"
          description={
            <ul style={{ marginBottom: 0, paddingLeft: 20 }}>
              <li>O cliente poderá enviar mensagens novamente</li>
              <li>O sistema de IA voltará a processar as mensagens</li>
              <li>Todos os campos de detecção serão resetados</li>
              <li>Se for realmente um bot, ele poderá ser detectado novamente</li>
            </ul>
          }
          type="info"
          showIcon
          icon={<CheckCircleOutlined />}
        />

        <Text type="secondary" style={{ fontSize: '12px', fontStyle: 'italic' }}>
          Use esta função apenas se tiver certeza de que o cliente foi marcado incorretamente como bot.
        </Text>
      </Space>
    </Modal>
  );
};

export default UnmarkAiBotModal;
